export const STRIPE_MAX_AMOUNT = 999999.99;
export const STRIPE_MIN_AMOUNT = 1;